// The product widget (section 6.4): "Free" plus `name · amount currency` per product of the branch; writes
// { productId, amount, currency } (D-22).
import { useMemo } from 'react';
import type { Product } from '../../api/types';
import { Select } from '../../ui/inputs';
import { productLabelOf } from '../ContentContext';
import { useWidgetEnv, type WidgetProps } from './context';

export function ProductSelect({ param: p, value, onCommit, disabled, compact, id }: WidgetProps) {
  const { catalog } = useWidgetEnv();
  const products = useMemo(() => [...catalog.productList].sort((a, b) => a.name.localeCompare(b.name)), [catalog.productList]);
  const current = value && typeof value === 'object' && !Array.isArray(value) ? (value as { productId?: string }).productId ?? '' : '';
  const choose = (itemId: string) => {
    if (!itemId) {
      onCommit(null);
      return;
    }
    const product = products.find((x) => x.itemId === itemId) ?? catalog.products.get(itemId);
    if (!product) return;
    onCommit(valueOf(product));
  };
  const known = products.some((x) => x.itemId === current);
  return (
    <Select id={id} size={compact ? 's' : 'm'} value={current} onChange={(e) => choose(e.target.value)} disabled={disabled} aria-label={p.displayName ?? p.name}>
      <option value="">Free</option>
      {!known && current && <option value={current}>{current} (not in this branch)</option>}
      {products.map((x) => (
        <option key={x.id} value={x.itemId}>
          {productLabelOf(x)}
        </option>
      ))}
    </Select>
  );
}

export function valueOf(product: Product) {
  const price = product.price as unknown as { amount?: number | string; currency?: string } | null;
  return { productId: product.itemId, amount: price?.amount ?? 0, currency: price?.currency ?? 'USD' };
}
